export { default as FactorBar } from './FactorBar';
